import { TrendingUp, TrendingDown } from "lucide-react";
import { useEffect, useState } from "react";
import "./ReportAnalysisTab.css";

export function MetricCard({ title, value, prefix = "", suffix = "", growth, prevValue, icon, highlight }) {
    const [displayed, setDisplayed] = useState(0);
    const isPositive = growth !== undefined && growth >= 0;

    useEffect(() => {
        if (typeof value === "number") {
            let start = 0;
            const end = value;
            const duration = 800;
            const step = (end / duration) * 16;
            const timer = setInterval(() => {
                start += step;
                if (start >= end) {
                    setDisplayed(end);
                    clearInterval(timer);
                }
                else setDisplayed(Math.floor(start));
            }, 16);
            return () => clearInterval(timer);
        }
    }, [value]);

    const displayValue = typeof value === "number" ? displayed.toLocaleString() : value;

    return (
        <div className={`dash-card p-5 flex flex-col gap-3 animate-count ${highlight ? "border-primary/30 bg-accent" : ""}`}>
            <div className="flex items-start justify-between">
                <span className="text-sm font-medium text-muted-foreground">{title}</span>
                {icon && <span className="text-2xl">{icon}</span>}
            </div>
            <div className="flex items-end gap-2">
                <span className="text-2xl font-bold text-foreground">
                    {prefix}{displayValue}{suffix}
                </span>
            </div>
            {(growth !== undefined || prevValue) && (
                <div className="flex items-center justify-between">
                    {growth !== undefined && (
                        <span className={`flex items-center gap-1 text-xs font-semibold ${isPositive ? "text-positive" : "text-negative"}`}>
                            {isPositive ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                            {isPositive ? "+" : ""}{growth.toFixed(1)}% vs last period
                        </span>
                    )}
                    {prevValue && <span className="text-xs text-muted-foreground">Prev: {prevValue}</span>}
                </div>
            )}
        </div>
    );
}